<template>
  <svg id="verwarming" viewBox="0 0 85 85">
    <path
      d="M44.9,15.7h1.8v35.7h-1.8V15.7z M32.3,15.7h1.8v35.7h-1.8V15.7z M19.8,15.7h1.8v35.7h-1.8V15.7z M17.1,53.5
                c0,0.2-0.1,0.5-0.1,0.7c-0.3,1.1-1.3,2-2.5,2c-1.2,0-2.2-0.9-2.5-2c-0.1-0.2-0.1-0.4-0.1-0.7v-2V15.7v-2.7V7.4
                c0-1.5,1.2-2.7,2.7-2.7c1.5,0,2.7,1.2,2.7,2.7v5.7v2.7v35.7V53.5z M29.6,53.5c0,0.2-0.1,0.5-0.1,0.7c-0.3,1.1-1.3,2-2.5,2
                c-1.2,0-2.2-0.9-2.5-2c-0.1-0.2-0.1-0.4-0.1-0.7v-2V15.7v-2.7V7.4c0-1.5,1.2-2.7,2.7-2.7c1.5,0,2.7,1.2,2.7,2.7v5.7v2.7v35.7V53.5z
                 M42.2,53.5c0,0.2-0.1,0.5-0.1,0.7c-0.3,1.1-1.3,2-2.5,2c-1.2,0-2.2-0.9-2.5-2c-0.1-0.2-0.1-0.4-0.1-0.7v-2V15.7v-2.7V7.4
                c0-1.5,1.2-2.7,2.7-2.7c1.5,0,2.7,1.2,2.7,2.7v5.7v2.7v35.7V53.5z M54.7,53.5c0,0.2-0.1,0.5-0.1,0.7c-0.3,1.1-1.3,2-2.5,2
                c-1.2,0-2.2-0.9-2.5-2c-0.1-0.2-0.1-0.4-0.1-0.7v-2V15.7v-2.7V7.4c0-1.5,1.2-2.7,2.7-2.7c1.5,0,2.7,1.2,2.7,2.7v5.7v2.7v35.7V53.5z
                 M59.6,51.5h-2.2V14.4v-7c0-3-2.4-5.4-5.3-5.4c-3,0-5.4,2.4-5.4,5.4v5.7h-1.8V7.4c0-3-2.4-5.4-5.4-5.4c-3,0-5.3,2.4-5.3,5.4v5.7
                h-1.9V7.4c0-3-2.4-5.4-5.3-5.4s-5.4,2.4-5.4,5.4v5.7h-1.8V7.4c0-3-2.4-5.4-5.4-5.4c-3,0-5.3,2.4-5.3,5.4v5.7H5.3v-2.5
                C6.5,10,7.4,8.8,7.4,7.4C7.4,5.5,5.8,4,4,4C2.1,4,0.6,5.5,0.6,7.4c0,1.4,0.8,2.6,2.1,3.1v3.9v45.3C2.6,60.4,3.2,61,4,61
                s1.3-0.6,1.3-1.3V15.7h3.7v37.1v0.7c0,3,2.4,5.4,5.3,5.4c2.7,0,4.9-2.1,5.3-4.7h2c0.3,2.6,2.6,4.7,5.3,4.7s4.9-2.1,5.3-4.7h2
                c0.3,2.6,2.6,4.7,5.3,4.7s4.9-2.1,5.3-4.7h2c0.3,2.6,2.6,4.7,5.3,4.7c2.7,0,4.9-2.1,5.3-4.7h2.3c0.9,0,1.7,0.8,1.7,1.7v3.8
                c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3v-3.8C64,53.5,62,51.5,59.6,51.5"
    />
    <g transform="scale(0.5) translate(100,100)">
      <IconKruisAppendix />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import IconKruisAppendix from '@/components/icon/custom/templates/IconKruisAppendix.vue';

@Component({ components: { IconKruisAppendix } })
export default class IconVerwarmingKruis extends Vue {}
</script>
